
import apiSlice from "../api/api.slice.js";

export const userApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        leaveRequest: builder.mutation({
            query: ({payload,token}) => ({
                url: "Attendance/LeaveRequest",
                method: "POST",
                body:payload,
                headers: {
                    "Authorization": "Bearer " + token
                }
            }),
        }),
    }),
});
export default userApiSlice.reducer;

export const { useLeaveRequestMutation} = userApiSlice;

